import { useNotification } from 'hooks'
import { getVoucherInfo } from '../../api'
import { FC, useEffect, useState } from 'react'
import s from './VoucherBarcodeScanner.modules.scss'
import { IconButton, Input } from '@fullscreendigital/carrefour-dex-fe'
import { Box, CircularProgress, InputAdornment, Paper } from '@mui/material'
import { CloseMenu } from 'icons'
import { Icon } from 'components/core-ui/Icon'

interface VoucherBarcodeScannerProps {
  barcode: string
  setBarcode: (value: string) => void
  searchVoucher: () => Promise<void>
  clearCode: () => void
  isLoading: boolean
}

const VoucherBarcodeScanner: FC<VoucherBarcodeScannerProps> = props => {
  const { barcode, setBarcode, searchVoucher, clearCode, isLoading } = props

  return (
    <Paper className={s.scanContainer}>
      <div className={s.scannerControls}>
        <div className={s.scannerControlItem}>
          <Input
            autoFocus
            value={barcode}
            type="text"
            variant="outlined"
            label="Introdu codul voucherului"
            fullWidth
            onChange={event => setBarcode(event.currentTarget.value)}
            onBlur={event => {
              if (!barcode) {
                document.getElementById('barcode-scan-input').focus()
              }
            }}
            onKeyUp={event => {
              if (event.which === 0) {
                if (barcode) searchVoucher()
              }
            }}
            id="barcode-scan-input"
            required
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" className={s.clearIconAdornment} onClick={clearCode}>
                  <CloseMenu fill={'rgba(0, 0, 0, 0.87)'} />
                </InputAdornment>
              )
            }}
          />
        </div>
        <div className={s.buttonContainer}>
          <Box style={{ width: '100%' }}>
            <IconButton
              onClick={searchVoucher}
              sx={{ width: '100%' }}
              label="Cauta Voucher"
              variant="contained"
              startIcon={<Icon iconName="SearchOutlined" tiny={true} fill="white" />}
            />
          </Box>
        </div>
      </div>
      {isLoading && (
        <div style={{ display: 'flex' }}>
          <CircularProgress color="primary" style={{ margin: '40px auto' }} disableShrink />
        </div>
      )}
    </Paper>
  )
}

export default VoucherBarcodeScanner
